import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import _ from 'lodash';

const SET_COMPANY_ATTENDEES = 'modules/data/company_attendees/SET_COMPANY_ATTENDEES';

const initialState = fromJS([]);

const reducer = handleActions({
  [SET_COMPANY_ATTENDEES]: (state, action = {}) => fromJS(action.payload || []),
}, initialState);

export const setCompanyAttendeesAction = createAction(SET_COMPANY_ATTENDEES, (attendees) => (attendees));

export const getCompanyAttendeesAsync = (conference) => {
  return async (dispatch, getState, { apiAuth }) => {
    let resp = await apiAuth.get('/internal/company_attendees/', { params: { conference } });
    resp = _.get(resp, 'data');
    dispatch(setCompanyAttendeesAction(resp));

    return resp;
  };
};

export default reducer;